import {createRequestDataSource} from "@ngneat/elf-requests";
import { boostsStore } from "./boosts.store";
import {selectAllEntities} from "@ngneat/elf-entities";

export const getBoostsDataSource = createRequestDataSource({
  store: boostsStore,
  data$: () => boostsStore.pipe(selectAllEntities()),
  requestKey: "getBoosts",
  dataKey: "boosts",
});